import { HomeExamPaperOrganization } from './HomeExamPaperOrganization';
export default HomeExamPaperOrganization;